var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-card',{staticStyle:{"width":"100%"},attrs:{"bordered":false}},[_c('a-table',{attrs:{"loading":_vm.loading,"columns":_vm.columns,"data-source":_vm.dataSource,"pagination":false,"bordered":"","size":"middle"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }